module.exports = __webpack_public_path__ + "img/nu.f58c75cb.svg";